module.exports = "/static/assets/75b8bac2584541c0e536f8bf8c65387e.png";